import { defineClickEventStmtInstruction } from './DefineClickEvent';
import { defineRedirectOnPersistEventStmtInstruction } from './DefineRedirectOnPersistEvent';
import { removeClickEventStmtInstruction } from './RemoveClickEvent';
export const eventInstruction = `
## Event
Define events that can be triggered by the user or the system.

### Event commands

${defineClickEventStmtInstruction}
${removeClickEventStmtInstruction}
${defineRedirectOnPersistEventStmtInstruction}
`;
//# sourceMappingURL=eventInstruction.js.map